import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { supabase } from '@/lib/supabase';
import { useProfile } from '@/lib/providers';
import { LogOut, RotateCcw } from 'lucide-react';
import { LOGIN_PATH } from '@/lib/constants';

const RETENTION_DAYS = 30;

export function RestoreAccountScreen({ deletedAt }: { deletedAt: string }) {
  const { profile, refreshProfile } = useProfile();
  const [busy, setBusy] = useState(false);

  const purgeDate = new Date(
    new Date(deletedAt).getTime() + RETENTION_DAYS * 24 * 60 * 60 * 1000,
  );
  const purgeDateStr = purgeDate.toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const restore = async () => {
    if (!profile?.id) return;
    setBusy(true);
    const { error } = await supabase
      .from('profiles')
      .update({ deleted_at: null })
      .eq('id', profile.id);
    setBusy(false);
    if (error) {
      console.error('Restore failed:', error);
      return;
    }
    refreshProfile();
  };

  const logout = async () => {
    await supabase.auth.signOut();
    window.location.href = LOGIN_PATH;
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <h1 className="text-2xl font-semibold">Account staat gepland voor verwijdering</h1>
        <p className="text-muted-foreground">
          Je account wordt op{' '}
          <span className="font-semibold text-foreground">{purgeDateStr}</span>{' '}
          definitief verwijderd. Wil je je account behouden? Herstel het dan nu.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            onClick={restore}
            disabled={busy}
            className="bg-green-600 hover:bg-green-700"
          >
            <RotateCcw className="mr-2 h-4 w-4" />
            {busy ? 'Bezig...' : 'Herstel mijn account'}
          </Button>
          <Button variant="outline" onClick={logout} disabled={busy}>
            <LogOut className="mr-2 h-4 w-4" />
            Uitloggen en verwijdering doorlaten
          </Button>
        </div>
      </div>
    </div>
  );
}
